import type { ValueOf } from "type-fest"

/**
 * 选项: 全部
 * 传参时需要删除掉
 */
export const OPTION_ALL = -1

export const NoPermissionPageName = "ErrorPage403"

/**
 * PreCheckoutTypeConstants
 */
const PreCheckoutTypeConstants = {
  // PACKAGE_END = 3, // 包段结束自动预结账
  // TIME_AUTO = 2, // 设置时间自动预结账
  // TIME_LAG = 1, // 设置时长自动预结账
  NOW: 1, // 立即预结账
  RESERVATION: 2, // 预约预结账
  RESERVATION_BY_PACKAGE: 3, // 包段自动预结账
} as const

type PRE_CHECKOUT_TYPE_VALUE = ValueOf<typeof PreCheckoutTypeConstants>

type PRE_CHECKOUT_TYPE_STRING = 'NOW' | 'PACKAGE_END' | 'TIME_AUTO' | 'TIME_LAG'

/**
 * PreCheckoutTypeMap
 */
const PreCheckoutTypeMap: Record<PRE_CHECKOUT_TYPE_STRING, PRE_CHECKOUT_TYPE_VALUE> = {
  NOW: PreCheckoutTypeConstants.NOW,
  PACKAGE_END: PreCheckoutTypeConstants.RESERVATION_BY_PACKAGE,
  TIME_AUTO: PreCheckoutTypeConstants.RESERVATION,
  TIME_LAG: PreCheckoutTypeConstants.RESERVATION,
}

interface CommissionType {
  commissionType: 1 | 2 | 3 | 4
  commissionTypeName: string
  commissionTypeDesc: string
  commissionTypeIcon: string
  commissionTypeIconBgColor?: string
  commissionTypeIconSize?: string
}

// JZTODO 前端的定义,需要修改以适配后端
const CommissionTypeDetail = {
  GOODS_COMMISSION: {
    GOODS_COMMISSION_1: 11,
    GOODS_COMMISSION_2: 12,
  },
  TABLE_COMMISSION: {
    TABLE_COMMISSION_1: 21,
  },
  MEMBER_COMMISSION: {
    MEMBER_COMMISSION_1: 31,
  },
  OVERTIME_COMMISSION: {
    OVERTIME_COMMISSION_1: 41,
  },
} as const

/**
 * CommissionTypeConstants
 */
const CommissionTypeConstants: Record<string, CommissionType> = {
  /**
   * 商品提成
   */
  GOODS_COMMISSION: {
    commissionType: 1,
    commissionTypeName: '商品提成',
    commissionTypeDesc: '根据商品的价格或收入给提成人核算提成',
    commissionTypeIcon: 'settings-goods-commission',
  },
  /**
   * 桌台提成
   */
  TABLE_COMMISSION: {
    commissionType: 2,
    commissionTypeName: '桌台提成',
    commissionTypeDesc: '根据订单的桌台费和夜间服务费收入给提成人核算提成',
    commissionTypeIcon: 'settings-table-commission',
  },
  /**
   * 会员提成
   */
  MEMBER_COMMISSION: {
    commissionType: 3,
    commissionTypeName: '会员提成',
    commissionTypeDesc: '根据会员充值的实付金额给提成人核算提成',
    commissionTypeIcon: 'settings-member-commission',
  },
  /**
   * 加班提成
   */
  OVERTIME_COMMISSION: {
    commissionType: 4,
    commissionTypeName: '加班提成',
    commissionTypeDesc: '根据开班和交班时间给提成人核算提成',
    commissionTypeIcon: 'settings-overtime-commission',
    commissionTypeIconBgColor: '#E37318',
    commissionTypeIconSize: '24px',
  },
}

export { CommissionTypeConstants, CommissionTypeDetail }
export type { CommissionType }

export { PreCheckoutTypeConstants, PreCheckoutTypeMap }
export type { PRE_CHECKOUT_TYPE_STRING, PRE_CHECKOUT_TYPE_VALUE }
